export const GLOBAL_SEARCH_THEME = 'secondary';
